<template>
  <div class="main" ref="main" />
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'EChart',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.update()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      // 基于准备好的dom，初始化echarts实例
      this.chart = echarts.init(this.$refs.main)
      // 绘制图表
      this.update()
    },
    update() {
      this.chart.setOption(this.options)
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
}
</style>
